import MarkerManager from "./markerManager.js";
import { MAP_DEFAULT_CONFIG } from "./consts.js";
import { setOptions, importLibrary } from "@googlemaps/js-api-loader";

export class GoogleMap {
    constructor(params, stateManager) {
        this.config = {
            ...this.defaults(),
            ...params,
        };
        if (!this.config.api_key || !this.config.map_id) return;

        this.stateManager = stateManager;
        if (
            !this.stateManager.elements.root ||
            !this.stateManager.elements.propertyContainer
        )
            return;

        this.markerManager = null;
        this.map = null;
        this.init();
    }

    defaults() {
        return {
            api_key: null,
            map_id: null,
        };
    }

    init() {
        this.loadMap();
    }

    async loadMap() {
        setOptions({
            key: this.config.api_key,
            version: "weekly",
        });

        const { Map } = await importLibrary("maps");
        await importLibrary("marker");

        this.initializeMap(Map);
        this.markerManager = new MarkerManager(this.map, this.stateManager);
        await this.markerManager.initializeClusterers();
        this.setupMapEventListeners();
        this.stateManager.syncSelectFromHash();
    }

    initializeMap(Map) {
        this.map = new Map(this.stateManager.elements.root, {
            ...MAP_DEFAULT_CONFIG,
            mapId: this.config.map_id,
        });
    }

    // マップの表示範囲が変更されたときのイベントリスナー
    setupMapEventListeners() {
        this.map.addListener("idle", () => {
            this.stateManager.fetchAndUpdateMarkers(
                this.map,
                this.markerManager
            );
        });
    }
}
